// https://github.com/axios/axios
// https://github.com/imcvampire/vue-axios

import Vue from "vue"
import axios from "axios"
// import store from "../store"

Vue.prototype.$axios = axios

axios.defaults.timeout = 10000
axios.defaults.baseURL = "https://api.signal.bz"
// axios.defaults.baseURL = "https://test-api.signal.bz"
// axios.defaults.baseURL = "http://localhost:3000"
//axios.defaults.baseURL = "https://3fx7vjjr28.execute-api.ap-northeast-2.amazonaws.com/production" //lambda

function axiosErrorHandler(error) {
  // store.dispatch("showSnackbar", error);
  return Promise.reject(error.response)
}

axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return axiosErrorHandler(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return axiosErrorHandler(error)
  }
)
